import { forwardRef, useEffect, useState } from "react";
import "jq-scrollable";
import { makeArray, setTimeout } from "zeta-dom/util";
import { classNames, useDispose, useMemoizedFunction } from "zeta-dom-react";
import { Mixin } from "brew-js-react";

export interface CarouselProps extends React.ComponentPropsWithRef<'div'> {
    interval?: number;
    generateThumb?: (index: number, active: boolean, onClick: () => void) => JSX.Element;
}

function generateThumbDefault(index: number, active: boolean, onClick: () => void) {
    return (<i key={index} className={classNames({ active })} onClick={onClick}></i>);
}

export const Carousel = forwardRef<HTMLDivElement, CarouselProps>((props, ref) => {
    const { children: _, generateThumb, ..._props } = props;
    const children = makeArray(props.children);
    const count = children.length;

    const [currentIndex, setCurrentIndex] = useState(0);
    const dispose = useDispose();
    const scrollToIndex = useMemoizedFunction((i: number) => {
        dispose();
        dispose.push(setTimeout(() => {
            scrollToIndex((i + 1) % (count || 1));
        }, props.interval || 5000));
        setCurrentIndex(i);
    });

    useEffect(() => {
        scrollToIndex(0);
    }, [scrollToIndex]);

    return (
        <div {..._props} {...Mixin.use(ref, classNames('eac-carousel', props.className))}>
            <div className="eac-carousel-content">
                <ul>
                    {children.map((v, i) => (<li key={i} className={classNames({ active: currentIndex === i })}>{v}</li>))}
                </ul>
            </div>
            <div className="eac-carousel-dots">
                {children.map((_v, i) => (generateThumb || generateThumbDefault)(i, currentIndex === i, () => scrollToIndex(i)))}
            </div>
        </div>
    );
});
